import { render, staticRenderFns } from "./Appraisal.vue?vue&type=template&id=c33bbb94&"
import script from "./Appraisal.vue?vue&type=script&lang=ts&"
export * from "./Appraisal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports